import { SearchInput } from '../shared';
import { SortOrder, TakeLeaveSortType, TakeLeaveType } from '../enums';
import * as moment from 'moment';

export class GetTakeLeavesInput extends SearchInput<TakeLeaveSortType> {
    public employeeId?: number | null;
    public fromDate?: moment.Moment | null;
    public toDate?: moment.Moment | null;
    public takeLeaveType?: TakeLeaveType | null;

    constructor() {
        super(TakeLeaveSortType.EmployeeFullName);
        this.sortOrder = SortOrder.Ascending;
        this.employeeId = null;
        this.fromDate = null;
        this.toDate = null;
        this.takeLeaveType = null;
    }
}